module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-LightItalic.adf3224e.woff";